import { useEffect } from "react";
import { useLocation } from "react-router";
import { servicingUrl } from "@/lib/servicing";

/** Old Maintenance and Parts links (bookmarks, home-screen shortcuts, Slack
 * posts) land on the same page in servicing.sailgp.tech. `replace` keeps the
 * dead builds URL out of the back-button history. */
export function ServicingRedirectPage() {
  const { pathname, search, hash } = useLocation();
  const target = servicingUrl(pathname, search, hash);

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <p className="p-6 text-sm text-muted-foreground">
      Maintenance and Parts have moved to{" "}
      <a href={target} className="underline underline-offset-2 hover:text-foreground">
        servicing.sailgp.tech
      </a>
      . Taking you there…
    </p>
  );
}
